module.exports = __webpack_public_path__ + "static/media/Mailing-Clergy-FIRST-LETTER.8113209d.pdf";